import { Box, Typography, Grid, TextField, Button } from "@mui/material"
import { Fragment, useState } from "react"
import { Controller } from "react-hook-form"

const VerificationPayment = ({ control, errors, setValue, loading }: { control: any, errors: any, setValue: any, loading: boolean }) => {

  const [monthlyPaymentType, setMonthlyPaymentType] = useState<'credit_card' | 'bank_account'>('credit_card')

  const handleMonthlyTypeChange = (type: 'credit_card' | 'bank_account') => {
    setMonthlyPaymentType(type)
    setValue('payment_type', type === 'credit_card' ? 'monthly_credit_card' : 'bank_account')
  }

  const labelStyle = { fontSize: '13px!important', fontWeight: 500, color: '#242424', mb: 0.5 }
  const tabStyle = (active: boolean) => ({
    fontSize: '14px!important',
    fontWeight: active ? 600 : 400,
    color: active ? '#242424' : '#4D4D4D',
    backgroundColor: active ? 'white' : 'transparent',
    borderRadius: '20px',
    px: 3,
    py: 0.8,
    textTransform: 'none' as const,
    minWidth: 'auto',
    boxShadow: active ? '0 1px 3px rgba(0,0,0,0.1)' : 'none',
    '&:hover': { backgroundColor: active ? 'white' : 'rgba(0,0,0,0.04)' },
  })

  return <Fragment>
    <Grid item xs={12} sx={{ mt: 2 }}>
      <Typography sx={{ color: '#003187', fontWeight: 700, fontSize: '18px!important', mb: 2 }}>Monthly Payment Method</Typography>

      <Box sx={{ mt: 3, mb: 2, display: 'inline-flex', gap: 0.5, backgroundColor: '#E8E8E8', borderRadius: '24px', p: 0.5 }}>
        <Button onClick={() => handleMonthlyTypeChange('credit_card')} sx={tabStyle(monthlyPaymentType === 'credit_card')} disabled={loading}>Credit card</Button>
        <Button onClick={() => handleMonthlyTypeChange('bank_account')} sx={tabStyle(monthlyPaymentType === 'bank_account')} disabled={loading}>Bank account</Button>
      </Box>
      {monthlyPaymentType === 'credit_card' && <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Typography sx={labelStyle}>Card holder's name</Typography>
          <Controller
            control={control}
            name='monthly_card_holder_name'
            render={({
              field: { value, onChange },
            }) => {
              return (
                <TextField value={value} disabled={loading} error={errors.monthly_card_holder_name ? true : false} onChange={onChange} variant="outlined" size="small" sx={{ backgroundColor: 'white' }} fullWidth />
              );
            }}
          />
          {errors.monthly_card_holder_name && <Typography variant='error' sx={{ ml: 1 }}>{errors.monthly_card_holder_name.message}</Typography>}
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography sx={labelStyle}>Credit card number</Typography>
          <Controller
            control={control}
            name='monthly_card_number'
            render={({
              field: { value, onChange },
            }) => {
              return (
                <TextField error={errors.monthly_card_number ? true : false} fullWidth disabled={loading} value={value} onChange={onChange} name='monthly_card_number' size="small" sx={{ backgroundColor: 'white' }} />
              );
            }}
          />
          {errors.monthly_card_number && <Typography variant='error' sx={{ ml: 1 }}>{errors.monthly_card_number.message}</Typography>}
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography sx={labelStyle}>Expiry date</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <Controller
              control={control}
              name='monthly_card_expiry_month'
              render={({
                field: { value, onChange },
              }) => {
                return (
                  <TextField disabled={loading} type="text" variant="outlined" size="small" inputProps={{ maxLength: 2 }} error={errors.monthly_card_expiry_month ? true : false}
                    name='monthly_card_expiry_month' onChange={onChange} value={value} sx={{ backgroundColor: 'white' }} placeholder="MM" />
                );
              }}
            />
            <Typography sx={{ color: '#242424' }}>/</Typography>
            <Controller
              control={control}
              name='monthly_card_expiry_year'
              render={({
                field: { value, onChange },
              }) => {
                return (
                  <TextField disabled={loading} type="text" variant="outlined" size="small" inputProps={{ maxLength: 2 }} error={errors.monthly_card_expiry_year ? true : false}
                    name='monthly_card_expiry_year' onChange={onChange} value={value} sx={{ backgroundColor: 'white' }} placeholder="YY" />
                );
              }}
            />
          </Box>
          {errors.monthly_card_expiry_month && <Typography variant='error' sx={{ ml: 1 }}>{errors.monthly_card_expiry_month.message}</Typography>}
          {errors.monthly_card_expiry_year && <Typography variant='error' sx={{ ml: 1 }}>{errors.monthly_card_expiry_year.message}</Typography>}
        </Grid>
      </Grid>}
      {monthlyPaymentType === 'bank_account' && <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <Typography sx={labelStyle}>Account name</Typography>
          <Controller
            control={control}
            name='bank_account_name'
            render={({
              field: { value, onChange },
            }) => {
              return (
                <TextField disabled={loading} value={value} error={errors.bank_account_name ? true : false} onChange={onChange} variant="outlined" size="small" sx={{ backgroundColor: 'white' }} fullWidth />
              );
            }}
          />
          {errors.bank_account_name && <Typography variant='error' sx={{ ml: 1 }}>{errors.bank_account_name.message}</Typography>}
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography sx={labelStyle}>BSB</Typography>
          <Controller
            control={control}
            name='bank_account_bsb'
            render={({
              field: { value, onChange },
            }) => {
              return (
                <TextField error={errors.bank_account_bsb ? true : false} fullWidth onChange={onChange} value={value} disabled={loading} name='bank_account_bsb' size="small" sx={{ backgroundColor: 'white' }} />
              );
            }}
          />
          {errors.bank_account_bsb && <Typography variant='error' sx={{ ml: 1 }}>{errors.bank_account_bsb.message}</Typography>}
        </Grid>
        <Grid item xs={12} sm={4}>
          <Typography sx={labelStyle}>Account number</Typography>
          <Controller
            control={control}
            name='bank_account_number'
            render={({
              field: { value, onChange },
            }) => {
              return (
                <TextField disabled={loading} value={value} error={errors.bank_account_number ? true : false} onChange={onChange} variant="outlined" size="small" sx={{ backgroundColor: 'white' }} fullWidth />
              );
            }}
          />
          {errors.bank_account_number && <Typography variant='error' sx={{ ml: 1 }}>{errors.bank_account_number.message}</Typography>}
        </Grid>
      </Grid>}
    </Grid>
  </Fragment>
}

export default VerificationPayment
